import "./tailwind.css";
import { BrowserRouter, Route, Routes, useLocation } from "react-router-dom";
import CustomerList from "./views/employee/CustomerList";
import Customer from "./views/employee/Customer";
import UpdatePhone from "./views/employee/UpdatePhone";
import Purchase from "./views/employee/Purchase";
import Exchange from "./views/employee/Exchange";
import TransactionList from "./views/employee/TransactionList";
import EmployeeLogin from "./views/employee/EmployeeLogin";
import CustomerPointsLookup from "./views/customer/CustomerPointsLookup";
import { useUserSession } from "./hooks/userSession";
import { Toaster } from "./components/ui/toaster";

// Modern components
import ModernHeader from "./components/modern/ModernHeader";
import ModernFooter from "./components/modern/ModernFooter";
import ModernHeroSection from "./components/modern/ModernHeroSection";

function AppContent() {
  const userSession = useUserSession();
  const location = useLocation();

  return (
    <div className="min-h-screen bg-background text-foreground">
      {/* Modern Header - Always visible for easy navigation */}
      <ModernHeader currentSession={userSession} />

      {/* Main Content */}
      <main className="flex-1">
        {/* Hero Section - Only show on home page for non-logged in users */}
        {!userSession.userSessionState.isLoggedIn && location.pathname === '/' && (
          <ModernHeroSection />
        )}

        {/* Routes */}
        <div className="container max-w-screen-xl py-8">
          <Routes>
            {!userSession.userSessionState.isLoggedIn && (
              <>
                <Route path="/" element={<div />} />
                <Route path="/index.html" element={<div />} />
              </>
            )}
            {userSession.userSessionState.isLoggedIn && (
              <>
                <Route
                  path="/"
                  element={<CustomerList currentSession={userSession} />}
                />
                <Route
                  path="/index.html"
                  element={<CustomerList currentSession={userSession} />}
                />
              </>
            )}
            <Route
              path="/myPoints"
              element={<CustomerPointsLookup />}
            />
            <Route
              path="/customer/points"
              element={<CustomerPointsLookup />}
            />
            <Route
              path="/employee/login"
              element={<EmployeeLogin currentSession={userSession} />}
            />
            <Route
              path="/customer/new"
              element={<Customer currentSession={userSession} />}
            />
            <Route
              path="/customer/update-phone"
              element={<UpdatePhone currentSession={userSession} />}
            />
            <Route
              path="/customer/:id"
              element={<Customer currentSession={userSession} />}
            />
            <Route
              path="/customer/list"
              element={<CustomerList currentSession={userSession} />}
            />
            <Route
              path="/customer/:id/purchase/new"
              element={<Purchase currentSession={userSession} />}
            />
            <Route
              path="/customer/:id/exchange/new"
              element={<Exchange currentSession={userSession} />}
            />
            <Route
              path="/customer/:id/transactions"
              element={<TransactionList currentSession={userSession} />}
            />
          </Routes>
        </div>
      </main>

      {/* Modern Footer - Always visible */}
      <ModernFooter />

      {/* Toast notifications */}
      <Toaster />
    </div>
  );
}

function App() {
  return (
    <BrowserRouter>
      <AppContent />
    </BrowserRouter>
  );
}

export default App;